<template>
  <div>
    <div
      class="custom-container-fluid text-light pt-5 pb-5"
      style="background: #06192b"
    >
      <div class="row">
        <div class="col-md-6 col-12 mb-5">
          <img src="@/assets/logo_white.png" style="width:48px;" alt="" class="img-fluid pb-5" />
          <p class="col-md-9 col-12 mb-5">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean elit
            adipiscing lectus mauris. Convallis facilisis tellus diam aliquam.
            Quis lorem tellus sed ipsum adipiscing. Congue elementum sed et
            ullamcorper feugiat accumsan pharetra, faucibus.
          </p>
          <div class="mb-3">
            <i class="fa fa-envelope"></i> info@startupcoachschool.com
          </div>
          <div>
            <i class="fa fa-2x fa-mobile-phone"></i> +233 567 879 890
          </div>
        </div>
        <div class="col-md-2 col-6">
          <div class="font-weight-bold mb-3" style="font-family:'gothamMedium">Support</div>
          <div>FAQs</div>
          <div>How It Works</div>
        </div>
        <div class="col-md-2 col-6">
          <div class="font-weight-bold mb-3" style="font-family:'gothamMedium">Links</div>
          <div>Home</div>
          <div>About</div>
          <div>Join the school</div>
          <div>Contact Us</div>
        </div>
        <div class="col-md-2">
          <div class="font-weight-bold mb-3" style="font-family:'gothamMedium">Follow Us</div>
          <div class='mb-3'>
            <i class="fa fa-linkedin footer-icon"></i> LinkedIn
          </div>
          <div>
            <i class="fa fa-instagram footer-icon"></i> Instagram
          </div>
        </div>
      </div>
    </div>
    <div class="footer pt-4 pb-4">
      <h5 class="text-center">&#169; Ghana Tech Lab 2020</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.footer-icon{
  background: white;
    color: black;
    padding: 3px;
    border-radius: 2px;
}
.footer{
  background: #1A0B04;
  color:white;

}
</style>